import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { aesHash } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  constructor() { }

  hashHmacSha512(value) {
    return CryptoJS.HmacSHA512(value, 'cyberpower@TP08!').toString(CryptoJS.enc.Hex).toUpperCase();
  }

  hashMd5(value) {
    return CryptoJS.MD5(value).toString().toUpperCase();
  }

  hashHmacSha512ForContent(value) {
    const timeStamp = new Date().getTime().toString().substr(0, 10);
    const data = JSON.stringify(value);
    const result = CryptoJS.HmacSHA512(data, timeStamp).toString(CryptoJS.enc.Hex);
    return result;
  }

  hashHmacSha1(value) {
    return CryptoJS.HmacSHA1(value, 'abcdefghjiklmn').toString(CryptoJS.enc.Hex).toUpperCase();
  }

  aesEncrypt(value) {
    if (value !== undefined && value !== null) {
      const val = typeof value === 'string' ? value : JSON.stringify(value);
      const key = CryptoJS.enc.Utf8.parse(aesHash.secretKey);
      const iv = CryptoJS.enc.Utf8.parse(aesHash.ivKey);
      const encryptedData = CryptoJS.AES.encrypt(val, key,
      {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
      }).toString();
      return encodeURIComponent(encryptedData);
    }
    return null;
  }

  aesDecrypt(value) {
    if (value !== undefined && value !== null) {
      const key = CryptoJS.enc.Utf8.parse(aesHash.secretKey);
      const iv = CryptoJS.enc.Utf8.parse(aesHash.ivKey);
      const encryptedData = decodeURIComponent(value);
      const decryptedData = CryptoJS.AES.decrypt(encryptedData, key,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }).toString(CryptoJS.enc.Utf8);
      return decryptedData;
    }
    return null;
  }
}
